import { render, staticRenderFns } from "./Zoomer.vue?vue&type=template&id=6b8596b2&"
import script from "./Zoomer.vue?vue&type=script&lang=js&"
export * from "./Zoomer.vue?vue&type=script&lang=js&"
import style0 from "./Zoomer.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/easy_dev/extranet/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6b8596b2')) {
      api.createRecord('6b8596b2', component.options)
    } else {
      api.reload('6b8596b2', component.options)
    }
    module.hot.accept("./Zoomer.vue?vue&type=template&id=6b8596b2&", function () {
      api.rerender('6b8596b2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/layout/components/Zoomer/Zoomer.vue"
export default component.exports